import React, { useState } from 'react';
import { orange, blue, green, purple, teal,red, amber } from '@mui/material/colors';
import classNames from 'classnames';
import TopupWalletAmazon from './TopupWalletAmazon';
import TopupRequestedList from './TopupRequestedList';
import BalanceWalletAmazon from './BalanceWalletAmazon';
import WithdrawalRequestedList from './WithdrawalRequestedList';
import CommissionList from './CommissionList';
import { getUserData } from '../auth';
import BalanceWalletCustomerAmazon from './BalanceWalletCustomerAmazon';
import MenuIcon from '@mui/icons-material/Menu'; // Mobile menu icon
import CloseIcon from '@mui/icons-material/Close'; // Close icon
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; // TopUp icon
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'; // TopUp Requested icon
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'; // Balance icon
import PaymentsIcon from '@mui/icons-material/Payments'; // Withdrawal Requested icon
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; // Commission Earned icon
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import { useNavigate } from 'react-router-dom';
import TransactionsTableTrue from './TransactionsTableTrue';
import TransactionsTableFalse from './TransactionsTableFalse';

 const TopupWalletViewAmazon = () => {
    // Retrieve user data and roles
    const userData = getUserData();
    const roles = userData?.role || [];
    const navigate=useNavigate()
    // State to track the active tab
    const [activeTab, setActiveTab] = useState("userProfileTab");
    const [isSidebarActive, setIsSidebarActive] = useState(false);

    // Helper variables for role-based access
    const canAccessTopUp = roles.some(role => 
        ["ROLE_ADMIN", "ROLE_VENDER", "ROLE_CUSTOMER"].includes(role)
    );
    const canAccessVendorFeatures = roles.some(role => 
        ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)
    );
    const canAccessCustomer = roles.includes("ROLE_CUSTOMER");

    // Tab configuration with icons
 
    const tabs = [
      {
        id: "userProfileTab",
        label: "TopUp", 
        icon: <AccountBalanceIcon sx={{ color: orange[500], marginRight: 1 }} />, // 🟠 Orange for TopUp
        component: <TopupWalletAmazon />,
        condition: canAccessTopUp,
      },
      {
        id: "shopDetailsTab",
        label: "TopUp Requested",
        icon: <RequestQuoteIcon sx={{ color: blue[500], marginRight: 1 }} />, // 🔵 Blue for requested
        component: <TopupRequestedList />,
        condition: canAccessTopUp,
      },
      {
        id: "balanceTab",
        label: "Balance (Vendor)",
        icon: <AccountBalanceWalletIcon sx={{ color: green[500], marginRight: 1 }} />, // 🟢 Green for balance
        component: <BalanceWalletAmazon />,
        condition: canAccessVendorFeatures,
      },
      {
        id: "balanceCustomerTab",
        label: "Balance (Customer)",
        icon: <AccountBalanceIcon sx={{ color: teal[500], marginRight: 1 }} />, // 🟩 Teal for customer balance
        component: <BalanceWalletCustomerAmazon />,
        condition: canAccessCustomer,
      },
      {
        id: "WithdrawalTab",
        label: "Withdrawal Requested",
        icon: <PaymentsIcon sx={{ color: purple[500], marginRight: 1 }} />, // 🟣 Purple for withdrawals
        component: <WithdrawalRequestedList />,
        condition: canAccessVendorFeatures,
      },
      {
        id: "CommissionTab",
        label: "Commission Earned",
        icon: <MonetizationOnIcon sx={{ color: amber[700], marginRight: 1 }} />, // 💛 Gold/Amber for earnings
        component: <TransactionsTableFalse />,
        condition: canAccessVendorFeatures,
      },
      {
        id: "CommissionTaba",
        label: "Transaction to Gain",
        icon: <MonetizationOnIcon sx={{ color: red[700], marginRight: 1 }} />, // 💛 Gold/Amber for earnings
        component: <TransactionsTableTrue />,
        condition: canAccessVendorFeatures,
      },
      {
        id: "Home",
        label: "Home",
        icon: <HomeIcon sx={{ color: purple[500], marginRight: 1 }} />, // 🏠 Purple for Home
        component: null,
        condition: true,
        action: () => navigate('/'),
      },
      {
        id: "Dashboard",
        label: "Dashboard",
        icon: <DashboardIcon sx={{ color: teal[500], marginRight: 1 }} />, // 📊 Teal for Dashboard
        component: null,
        condition: true,
        action: () => navigate('/dashboard-customer'),
        condition:canAccessCustomer,
      },

      {
        id: "Dashboard",
        label: "Dashboard",
        icon: <DashboardIcon sx={{ color: teal[500], marginRight: 1 }} />, // 📊 Teal for Dashboard
        component: null,
        condition: true,
        action: () => navigate('/dashboard-vendor'),
        condition: canAccessVendorFeatures,

      },
      {
        id: "Logout", // 🚪 Logout Tab
        label: "Logout",
        icon: <LogoutOutlined sx={{ color: red[400], marginRight: 1 }} />, // 🔴 Red for logout
        component: null,
        condition: true,
        action: () => navigate('/account'),
      },
    ];
    
    const sidebarController = () => {
        setIsSidebarActive(!isSidebarActive);
    };

    return (
        <section className="shop py-80">
            <div className={`side-overlay ${isSidebarActive && "show"}`} 
                 onClick={sidebarController}></div>
            <div className="container container-lg">
                <div className="row">
                    {/* Sidebar Start */}
                    <div className="col-lg-3">
                        <div className={`shop-sidebar ${isSidebarActive && "active"}`}>
                            <button 
                                onClick={sidebarController}
                                type="button"
                                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
                            >
                                <CloseIcon />
                            </button>
                            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                            <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24 flex items-center gap-2">
                               Wallet Operations
                            </h6>
                                <ul className="max-h-540 overflow-y-auto scroll-sm">
                                    {tabs.filter(tab => tab.condition).map(tab => (
                                        <li className="mb-24" key={tab.id}>
                                            <a
                                                href={`#${tab.id}`}
                                                className={classNames(
                                                    "text-gray-900 hover-text-main-600 flex-align gap-8", 
                                                    { "text-main-600 font-semibold": activeTab === tab.id }
                                                )}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (tab.action) {
                                                        tab.action();
                                                    } else {
                                                        setActiveTab(tab.id);
                                                    }
                                                    setIsSidebarActive(false);
                                                }}
                                                
                                                style={{
                                                    outline: activeTab === tab.id ? '2px solid #EF6036' : 'none', // Focus indicator
                                                    outlineOffset: '2px',
                                                }}
                                            >
                                                {tab.icon} {tab.label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Sidebar End */}
                    
                    {/* Content Start */}
                    <div className="col-lg-9">
                        {/* Mobile Toggle Button */}
                        <div className="d-lg-none d-block mb-40">
                            <button
                                onClick={sidebarController}
                                type="button"
                                className="w-44 h-44 flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                            >
                                <MenuIcon />
                            </button>
                        </div>

                        {/* Main Content */}
                        <div className="tab-content">
                            {tabs.map(tab => tab.condition && (
                                <div
                                    key={tab.id}
                                    className={classNames("tab-pane fade", {
                                        "show active": activeTab === tab.id,
                                    })}
                                    id={tab.id}
                                    role="tabpanel"
                                >
                                    {tab.component}
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Content End */}
                </div>
            </div>
        </section>
    );
};

export default TopupWalletViewAmazon;